/* eslint-disable */
<template>
  <header class="site-header">

    <!-- Logo -->
    <router-link @click="scrollToTop()" to="/" class="logo-link">
      <img src="../assets/images/header.png" alt="Logo" class="logo-img" />
    </router-link>

    <!-- Ministry Title -->
    <div class="ministry-title">
      <p class="ministry-label">Sri Lanka</p>
      <h1 class="ministry-name">Ministry of Public Administration,<br>Home Affairs, Provincial Councils &amp; Local Government</h1>
    </div>

    <!-- Nav Actions -->
    <nav class="nav-actions">

      <!-- Help -->
      <button class="nav-btn" @click="openPDF" title="Help">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <span>Help</span>
      </button>

      <!-- Guest actions -->
      <template v-if="!user || !user.cus_nic">
        <router-link to="/" class="nav-btn" @click="scrollToTop()" title="Login">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"/>
          </svg>
          <span>Login</span>
        </router-link>

        <router-link to="/register" class="nav-btn nav-btn-accent" @click="scrollToTop()" title="Register">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
          </svg>
          <span>Register</span>
        </router-link>
      </template>

      <!-- Logged-in actions -->
      <template v-if="user && user.cus_nic">

        <!-- User greeting chip -->
        <div class="user-chip">
          <div class="user-avatar">{{ user.cus_name ? user.cus_name.charAt(0).toUpperCase() : 'U' }}</div>
          <span class="user-name">{{ user.cus_name }}</span>
        </div>

        <router-link to="/home" class="nav-btn" @click="scrollToTop()" title="Home">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
          </svg>
          <span>Home</span>
        </router-link>

        <router-link to="/profile" class="nav-btn nav-btn-blue" @click="scrollToTop()" title="Profile">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
          </svg>
          <span>Profile</span>
        </router-link>

        <!-- <router-link to="/changepassword" class="nav-btn nav-btn-red" @click="scrollToTop()" title="Change Password">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
          </svg>
          <span>Pass</span>
        </router-link> -->

        <router-link @click="handleLogout" to="/" class="nav-btn nav-btn-gold" title="Logout">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
          <span>Logout</span>
        </router-link>

      </template>
    </nav>

  </header>
</template>


<script>
import pdfUrl from '@/assets/images/online.pdf';
import { mapState, mapMutations } from "vuex";

export default {
  name: 'NavBar',
  computed: {
    ...mapState(["user"])
  },
  mounted() {
  window.addEventListener('scroll', this.handleScroll);

  if (!this.user || !this.user.cus_nic) {

    const storedUser =
      sessionStorage.getItem("user") ||
      localStorage.getItem("user");

    if (storedUser) {
      this.setUser(JSON.parse(storedUser));
      console.log("User restored in NavBar");
    }
  }
},
  
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapMutations(["setUser"]),

    openPDF() {
      window.open(pdfUrl, '_blank');
    },

    scrollToTop() {
      window.scrollTo(0, 0);
      return false;
    },

   handleLogout() {
  this.setUser("");

  sessionStorage.clear();
  localStorage.clear();

  this.$router.push("/");
},
  }
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

/* ── Header ── */
.site-header {
  position: sticky;
  top: 0; left: 0; right: 0;
  z-index: 1000;
  background: linear-gradient(135deg, #7c2d12 0%, #9a3412 60%, #c2440a 100%);
  box-shadow: 0 2px 16px rgba(124,45,18,0.35);
  display: flex;
  align-items: center;
  gap: 1.6rem;
  padding: 1rem 4%;
  font-family: 'DM Sans', sans-serif;
}

/* ── Logo ── */
.logo-link {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
}
.logo-img {
  height: 5.2rem;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.25));
  transition: transform 0.2s;
}
.logo-link:hover .logo-img { transform: scale(1.04); }

/* ── Ministry Title ── */
.ministry-title {
  flex: 1;
  min-width: 0;
}
.ministry-label {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.6);
  margin: 0 0 0.15rem;
}
.ministry-name {
  font-family: 'DM Serif Display', serif;
  font-size: clamp(1rem, 1.8vw, 1.4rem);
  color: #fff;
  line-height: 1.3;
  margin: 0;
  font-weight: 400;
}

/* ── Nav Actions ── */
.nav-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-shrink: 0;
  flex-wrap: wrap;
}

/* ── Nav Buttons ── */
.nav-btn {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.6rem 0.9rem;
  min-width: 5.2rem;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 0.7rem;
  color: #fff;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.15rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.18s;
  white-space: nowrap;
}
.nav-btn svg { width: 1.8rem; height: 1.8rem; stroke: #fff; }
.nav-btn span { font-size: 1.05rem; line-height: 1; }

.nav-btn:hover {
  background: rgba(255,255,255,0.25);
  border-color: rgba(255,255,255,0.4);
  transform: translateY(-1px);
}

/* Colour variants */
.nav-btn-accent {
  background: rgba(255,255,255,0.2);
  border-color: rgba(255,255,255,0.35);
}
.nav-btn-accent:hover { background: rgba(255,255,255,0.32); }

.nav-btn-blue  { background: rgba(99,132,222,0.55); border-color: rgba(99,132,222,0.7); }
.nav-btn-blue:hover { background: rgba(99,132,222,0.75); }

.nav-btn-red   { background: rgba(220,38,38,0.55); border-color: rgba(220,38,38,0.7); }
.nav-btn-red:hover { background: rgba(220,38,38,0.75); }

.nav-btn-gold  { background: rgba(180,130,30,0.55); border-color: rgba(180,130,30,0.7); }
.nav-btn-gold:hover { background: rgba(180,130,30,0.75); }

/* ── User Chip ── */
.user-chip {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 99px;
  padding: 0.4rem 1rem 0.4rem 0.4rem;
}
.user-avatar {
  width: 3rem; height: 3rem; border-radius: 50%;
  background: rgba(255,255,255,0.25);
  color: #fff;
  font-size: 1.3rem; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.user-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: #fff;
  max-width: 12rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Responsive ── */
@media (max-width: 900px) {
  .ministry-name { font-size: 1rem; }
  .ministry-label { display: none; }
  .nav-btn span { display: none; }
  .nav-btn { min-width: 4rem; padding: 0.7rem; }
  .user-name { display: none; }
  .user-chip { padding: 0.4rem; }
}

@media (max-width: 600px) {
  .site-header { padding: 0.8rem 3%; gap: 1rem; }
  .logo-img { height: 4rem; }
  .ministry-title { display: none; }
}
</style>